import { useQuery } from '@tanstack/react-query';
import { IConfig } from '../../Interfaces/IConfig';
import { customFetcher } from '../useFetch';

export const useGetConfig = () => {
  const { data: config, isLoading: isLoadingConfig } = useQuery<IConfig>({
    queryKey: ['config'],
    queryFn: () => customFetcher({ endpoint: '/config' }),
  });

  return { config, isLoadingConfig };
};

export const useGetPublicConfig = () => {
  const { data: config, isLoading: isLoadingConfig } = useQuery<IConfig>({
    queryKey: ['config/public'],
    queryFn: () => customFetcher({ endpoint: '/config/public' }),
  });

  return { config, isLoadingConfig };
};
